






































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Arrow from '../../../assets/svg/arrow-rounded.svg'

@Component({
    components: { Arrow }
})
export default class TicketPagination extends Vue {
    @Prop({required: true}) source: any[];
    @Prop({required: true, default: 5}) numElementsOnPage: number;
    // минимум - 7 (номер первой страницы, разделитель, три номера в середине, разделитель, номер последней страницы)
    @Prop({required: true, default: 7}) maxVisiblePageNumbers: number;

    currentPage = 1;

    created() {
        this.$emit('pageChanged', this.startIndex, this.endIndex);
    }

    get startIndex() {
        return this.numElementsOnPage * (this.currentPage - 1);
    }

    get endIndex() {
        return this.numElementsOnPage * this.currentPage;
    }

    get numberOfPages() {
        return Math.ceil(this.source.length / this.numElementsOnPage);
    }

    get visiblePageNumbers() {
        return Math.min(this.numberOfPages, this.maxVisiblePageNumbers);
    }

    get startPageNumbers() {
        if (this.numberOfPages < this.maxVisiblePageNumbers) {
            return Array.from({length: this.visiblePageNumbers}, (_, i) => i + 1);
        }
        // будет видно начальные номера страниц, разделитель и последний номер страницы
        if (this.currentPage <= this.visiblePageNumbers - 3) {
            return Array.from({length: this.visiblePageNumbers - 2}, (_, i) => i + 1);
        }
        // будет видно первый номер, разделитель и последние номера страниц
        if (this.currentPage > this.numberOfPages - (this.visiblePageNumbers - 3)) {
            return [1];
        }
        // будет видно первый номер, разделитель, средние номера страниц, разделитель и последний номер
        return [1];
    }

    get middlePageNumbers() {
        if (this.numberOfPages < this.maxVisiblePageNumbers) {
            return [];
        }
        // средних номеров не видно
        if (this.currentPage <= this.visiblePageNumbers - 3) {
            return [];
        }
        // средних номеров не видно
        if (this.currentPage > this.numberOfPages - (this.visiblePageNumbers - 3)) {
            return [];
        }
        // будет видно первый номер, разделитель, средние номера страниц, разделитель и последний номер
        return Array.from({length: this.visiblePageNumbers - 4}, (_, i) => i + 1 + this.currentPage - Math.floor((this.visiblePageNumbers - 4) / 2));
    }

    get endPageNumbers() {
        if (this.numberOfPages < this.maxVisiblePageNumbers) {
            return [];
        }
        // будет видно начальные номера страниц, разделитель и последний номер страницы
        if (this.currentPage <= this.visiblePageNumbers - 3) {
            return [this.numberOfPages];
        }
        // будет видно первый номер, разделитель и последние номера страниц
        if (this.currentPage > this.numberOfPages - (this.visiblePageNumbers - 3)) {
            return Array.from({length: this.visiblePageNumbers - 2}, (_, i) => this.numberOfPages - i).reverse();
        }
        // будет видно первый номер, разделитель, средние номера страниц, разделитель и последний номер
        return [this.numberOfPages];
    }

    @Watch('source')
    onSourceChanged() {
        this.currentPage = 1;
    }

    @Watch('currentPage')
    onChangePage() {
        this.$emit('pageChanged', this.startIndex, this.endIndex);
    }

    increasePage() {
        if (this.currentPage < this.numberOfPages) {
            this.currentPage++;
        }
    }

    decreasePage() {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    }
}
